import { createFileRoute, notFound } from "@tanstack/react-router";
import Brokerage from "@/modules/reports/pages/brokerage";
import { getUserOptions } from "creso-core/hooks";
import { isEmployeeUserWithEmployeeRole } from "creso-core/utils";

export const Route = createFileRoute(
  "/(auth)/_headed/reports/_layout/brokerage"
)({
  component: Brokerage,
  loader: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(getUserOptions());
    if (isEmployeeUserWithEmployeeRole(user)) {
      throw notFound({ routeId: "__root__" });
    }
  },
});
